import "./Footer.css";

const Footer = () => {
  return (
    <div className="row Footer">
      <div className="col-md-12">
        <h5> &nbsp 2021. Foodera. All rights reserved. </h5>
      </div>
    </div>
  );
};

export default Footer;
